import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export default gql`
  query GetDocumentsByCourse($courseId: String!) {
    documents(courseId: $courseId)
      @rest(type: "Document", path: "courses/{args.courseId}/documents") {
      ...Document
    }
  }
  ${documentFragment}
`;
